/* eslint-disable quote-props */
import { SxProps, Theme } from "@mui/material";

import { defaultTheme } from "../../styles/muiTheme";

export const style: SxProps = {
  width: "60px",
  height: "60px",
  border: "2px solid #FFFFFF",
  background: "#F4EFEB",
  padding: "0",
  borderRadius: "50%",
  overflow: "hidden",
  color: defaultTheme.palette.taupe.main,
  "& svg": {
    fontSize: 56,
  },
  "& span svg": {
    color: defaultTheme.palette.taupe.light,
  },
};

export const iconActionStyle = (theme: Theme) => ({
  position: "absolute",
  top: "2.1rem",
  cursor: "pointer",
  right: 0,
  width: "20px",
  height: "20px",
  backgroundColor: theme.palette.primary.main,
  borderRadius: "50%",
  display: "grid",
  placeItems: "center",
});

export const warningIconStyle = (theme: Theme) => ({
  position: "absolute",
  top: "-34px",
  right: "86px",
  width: "18px",
  height: "18px",
  borderRadius: "50%",
  display: "grid",
  placeItems: "center",
});
